<template>
  <div class="status-filter-toggle">
    <button
      v-for="(status, key) in statusTypes"
      :key="'status' + key"
      @click="setStatusFilter(key)"
      :class="{ active: key === value }"
    >
      {{ status.title }}
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapState("TestsStore", ["statusTypes"])
  },
  methods: {
    setStatusFilter(key) {
      if (this.value === key) {
        this.$emit("input", null);
        //this.statusFilter = null;
        return;
      }
      this.$emit("input", key);
      //this.statusFilter = key;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../styles/vars";

.status-filter-toggle {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  border: 1px solid #eee;
  height: @h4;
  border-radius: @hh;
  button {
    height: auto;
    flex: 1;
    font-size: 0.75rem;
    text-transform: uppercase;
    border-radius: 0;
    background-color: transparent;
    color: #888;
    margin: 0;
    &:first-child {
      border-radius: @hh 0 0 @hh;
    }
    &:last-child {
      border-radius: 0 @hh @hh 0;
    }
    &.active {
      background-color: #333;
      color: #fff;
    }
    & + button {
      border-left: 1px solid #eee;
    }
  }
}
</style>
